import { useState, useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Content } from "../../../components/Layout";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import { getTrainee } from "../../../hooks/api/listTrainees";

export default function TraineeLayout() {
  const { traineesId } = useParams();
  const { config, setbreadcrumb } = useWrapper();

  const [isLoadingTraineesData, setisLoadingTraineesData] = useState(true);
  const [isLoadingTraineesComments, setisLoadingTraineesComments] = useState(true);
  const [isWaitingResponse, setisWaitingResponse] = useState(false);
  useEffect(() => {
    setisWaitingResponse(isLoadingTraineesData);
  }, [isLoadingTraineesData]);

  const [trainee, settrainee] = useState();
  const [reloadTrainee, setreloadTrainee] = useState();
  const reloadTraineeData = () => {
    setreloadTrainee(JSON.stringify(new Date()));
  };
  useEffect(() => {
    (async () => {
      setisLoadingTraineesData(true);
      try {
        const _trainee = await getTrainee({
          id: traineesId,
          query: "?joins=files&joinsMany=commercials.course,commercials.institution",
          config,
        });

        let _files = {};
        for (const __file of _trainee?.files) {
          if (!!__file?.rg) _files.rg = __file.id;
          else if (!!__file?.proof_address) _files.proof = __file.id;
        }
        settrainee({
          ..._trainee,
          files: _files,
        });
      } catch (__error) {
        toast.error("Erro ao tentar carregar os dados do formando.");
        console.log("__error", __error);
      } finally {
        setisLoadingTraineesData(false);
      }
    })();
  }, [reloadTrainee]);

  const [traineeComments, settraineeComments] = useState();
  const [reloadCommentsTime, setreloadCommentsTime] = useState();
  const reloadTraineeComments = () => {
    setreloadCommentsTime(JSON.stringify(new Date()));
  };
  useEffect(() => {
    (async () => {
      try {
        const { data: _comments } = await api.get(`log-trainee?trainee_id=${traineesId}`, config);
        settraineeComments(_comments);
      } catch (__error) {
        toast.error("Erro ao tentar carregar os comentários do formando.");
        console.log("__error", __error);
      } finally {
        setisLoadingTraineesComments(false);
      }
    })();
  }, [reloadCommentsTime]);

  useEffect(() => {
    setbreadcrumb([
      { label: "Formandos", url: "/trainees" },
      { label: traineesId ? trainee?.name || "" : "Novo Formando" },
    ]);
  }, [trainee?.name]);

  return (
    <>
      {!isLoadingTraineesData ? (
        <Row>
          <Col>
            <Outlet
              context={{
                reloadTraineeData,
                trainee,
                settrainee,
                reloadTraineeComments,
                traineeComments,
                isLoadingTraineesComments,
                isLoadingTraineesData,
                setisLoadingTraineesData,
                isWaitingResponse,
                setisWaitingResponse,
              }}
            />
          </Col>
        </Row>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </>
  );
}
